/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createHook } from '../../core/factories/createHook.js';

import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetMarketResolutionIntegrityRow } from '../openapi-types.gen.js';
import { type useGetMarketResolutionIntegrityArgs, useGetMarketResolutionIntegritySpec } from '../specs/markets.spec.gen.js';

export type { GetMarketResolutionIntegrityRow } from '../openapi-types.gen.js';
export type { useGetMarketResolutionIntegrityArgs } from '../specs/markets.spec.gen.js';


/**
 * Available query params (forwarded automatically; pass via the
 * hook's args): pubkey.
 */
export const useGetMarketResolutionIntegrity = createHook(useGetMarketResolutionIntegritySpec);


/**
 * Hover/intent prefetch companion for `useGetMarketResolutionIntegrity`. Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * and writes the response into the SAME cache entry the reader hook
 * observes. The component owning the callback does NOT subscribe — no
 * re-renders on data, no NATS subscription. Idempotent: TanStack
 * `prefetchQuery` is a no-op when a fresh cache entry already exists.
 *
 *     function Link({ pubkey }) {
 *       const prefetch = usePrefetchGetMarketResolutionIntegrity();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({ pubkey })}
 *           onFocus={() => prefetch({ pubkey })}
 *         >…</a>
 *       );
 *     }
 */
export const usePrefetchGetMarketResolutionIntegrity = createPrefetchHook(useGetMarketResolutionIntegritySpec);
